import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquare } from '@fortawesome/free-solid-svg-icons';
import { useThemeStore } from '@core/theme/useThemeStore';
import { Job } from '@core/generated/gql-types';

interface FilledJobsProps {
  filledJobs: Job[];
  unfilledJobs: Job[];
}

const FilledJobs = ({ filledJobs, unfilledJobs }: FilledJobsProps) => {
  const { theme } = useThemeStore();

  const totalItems = filledJobs.length + unfilledJobs.length;

  const proportionFilled = filledJobs.length / (totalItems || 1);

  return (
    <div className="flex h-auto min-h-[140px] min-w-0 flex-row items-center overflow-hidden rounded-xl bg-white p-4 shadow">
      <div className="flex h-full min-w-0 flex-1 flex-col justify-between">
        <div className="text-md font-semibold">Filled jobs</div>
        <div className="mb-2 flex min-w-0 items-center gap-3">
          <div className="flex min-w-0 flex-1 flex-col">
            <div className="flex min-w-0 items-center">
              <FontAwesomeIcon
                icon={faSquare}
                className="mr-1 shrink-0 text-sm font-medium"
                style={{ color: theme?.secondaryBrandColor }}
              />
              <span className="truncate text-xl font-medium">
                {filledJobs.length} Filled
              </span>
            </div>

            <div className="flex min-w-0 items-center">
              <FontAwesomeIcon
                icon={faSquare}
                className="mr-1 shrink-0 text-sm font-medium"
                style={{ color: theme?.secondaryBrandColor10 }}
              />
              <span className="truncate text-xl font-medium">
                {unfilledJobs.length} Unfilled
              </span>
            </div>
          </div>
          <div className="aspect-square w-[min(7.5rem,36%)] shrink-0">
            <svg className="block h-full w-full" viewBox="0 0 80 80">
            <circle
              cx="40"
              cy="40"
              r="34"
              fill="none"
              stroke={theme?.secondaryBrandColor10}
              strokeWidth="8"
            />
            <circle
              cx="40"
              cy="40"
              r="34"
              fill="none"
              stroke={theme?.secondaryBrandColor}
              strokeWidth="8"
              strokeDasharray="213.6"
              strokeDashoffset="213.6"
              style={{
                strokeDashoffset: 213.6 - 213.6 * proportionFilled,
              }}
              strokeLinecap="round"
              transform="rotate(-90 40 40)"
            />
            <text
              x="40"
              y="40"
              textAnchor="middle"
              fontSize="18"
              fontWeight="bold"
              fill="#222"
            >
              {filledJobs.length}
            </text>
            <text x="40" y="55" textAnchor="middle" fontSize="12" fill="#888">
              Filled
            </text>
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilledJobs;
